import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { NEVER, Observable } from 'rxjs';

import { PlatformService } from '../platform/platform.service';
import { RedirectService } from '../redirect/redirect.service';

/**
 * While re-hydrating a Universal app on client side, routing is configured
 * to always do initial navigation even before all app initializers resolved.
 * This can lead to conditions where already requests will be done, even before app
 * has been fully initialized.
 * Also in cases when doing redirects within or short after app init, it's required
 * to block any further requests.
 */
@Injectable()
export class HttpBlockRequestInterceptor implements HttpInterceptor {
  private readonly isBrowser = this.platform.isBrowser;

  constructor(private readonly redirectService: RedirectService, private readonly platform: PlatformService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.isBrowser && this.redirectService.isRedirecting ? NEVER : next.handle(req);
  }
}
